import { SnowFall } from './components/SnowFall';

function App() {
  return (
    <div className="App">
      <SnowFall />
    </div>
  );
}

export default App;
